<template>
  <section class="app-main">
<!--    <div class="watermark"></div>-->
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key"/>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-main {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  width: auto;
}

.watermark {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100000;
  pointer-events: none;
  background: url('/static/admin/img/watermark.png') 0 0 repeat;
  background-size: 160px 160px;
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/admin/layout/components/AppMain.vue